'use strict';

var _ = require('lodash');
/**
 * Vertical Line
 *
 * Draws static vertical line
 *
 * @param d3Helper
 * @param chartConstants
 * @returns {Function}
 * @constructor
 */
var VerticalLine = function VerticalLine(d3Helper, chartConstants) {
  return function (xPropertyName, captionPropertyName) {
    var className = 'group-vertical-line';
    var uniqueClassName = className + ' ' + xPropertyName;
    var params, scales, data, withStrokeWidth, withOpacity, withOffsetX, withSize, withLastLine, withFirstLine, chartXAxisWidth, withTextLabelOffsetY, clipPath, withMultipleLine;
    var dataIsSet = false;
    var defaultColor = 'gray';
    var line = function line(container) {
      var strokeWidth = withStrokeWidth || 1;
      var opacity = withOpacity || 0.75;
      var offset_x = withOffsetX || 0;
      var textLabelOffsetY = withTextLabelOffsetY || 0;
      var rangeExtent = scales.yScale.rangeExtent ? scales.yScale.rangeExtent() : scales.yScale.range();
      var firstLine = withFirstLine;
      if (_.isUndefined(firstLine)) {
        firstLine = true;
      }
      if (withMultipleLine) {
        className = uniqueClassName;
      }
      var y1, y2;
      if (_.isUndefined(data) || !dataIsSet) {
        data = scales.xScale.domain();
      }
      if (withSize && withSize === chartConstants.VERTICAL_LINE.SIZE.CONTAINER) {
        y1 = params.containerHeight;
        y2 = 0;
      } else {
        y1 = rangeExtent[0];
        y2 = rangeExtent[1];
      }
      d3Helper.findChildrenByClass(container, className).remove();
      var group = d3Helper.createGroupElement(container, className);
      if (clipPath) {
        group.attr('clip-path', clipPath);
      }
      var verticalLine = group.selectAll('.vertical-line').data(data);
      var g = verticalLine.enter().append('g').attr({
        'class': function _class(d) {
          return ['vertical-line', d.className].join(' ');
        },
        'transform': function transform(d) {
          var val = d;
          if (xPropertyName) {
            val = d[xPropertyName];
          }
          return 'translate(' + [scales.xScale(val) + offset_x, 0] + ')';
        }
      }).style('visibility', function (d, i) {
        var val = d;
        if (xPropertyName) {
          val = d[xPropertyName];
          var translateX = scales.xScale(val);
          if (translateX + offset_x < 0 || _.isNumber(params.width) && translateX > params.width) {
            return 'hidden';
          }
        }
        if (i === 0 && firstLine === false) {
          return 'hidden';
        }
        return 'visible';
      });
      g.append('line').attr({
        'y1': y1,
        'y2': y2,
        'stroke-width': strokeWidth,
        'opacity': opacity,
        'stroke': function stroke(d) {
          return d.color || defaultColor;
        }
      });
      g.append('text').text(function (d) {
        return d[captionPropertyName];
      }).attr({
        'y': -5 + textLabelOffsetY,
        'font-size': '12px',
        'fill': function fill(d) {
          return d.color || defaultColor;
        },
        'text-anchor': function textAnchor(d) {
          return d.textAnchor || 'start';
        }
      });
      if (withLastLine) {
        var addionalG = group.append('g').attr({
          'class': 'vertical-line',
          'transform': 'translate(' + [params.width - strokeWidth / 2, 0] + ')'
        });
        addionalG.append('line').attr({
          'y1': y1,
          'y2': y2,
          'stroke-width': strokeWidth,
          'opacity': opacity,
          'stroke': defaultColor
        });
      }
    };

    /**
     *
     * @param {Array} value
     * @returns {line}
     */
    line.withData = function (value) {
      dataIsSet = true;
      data = value;
      return line;
    };
    line.chartXAxisWidth = function (value) {
      chartXAxisWidth = value;
      return line;
    };
    line.params = function (value) {
      params = value;
      return line;
    };
    line.scales = function (value) {
      scales = value;
      return line;
    };
    line.withSize = function (value) {
      withSize = value;
      return line;
    };
    line.withStrokeWidth = function (value) {
      withStrokeWidth = value;
      return line;
    };
    line.withOpacity = function (value) {
      withOpacity = value;
      return line;
    };
    line.withOffsetX = function (value) {
      withOffsetX = value;
      return line;
    };
    line.withFirstLine = function (value) {
      withFirstLine = value;
      return line;
    };
    line.withLastLine = function (value) {
      withLastLine = value;
      return line;
    };
    line.withTextLabelOffsetY = function (value) {
      withTextLabelOffsetY = value;
      return line;
    };
    line.clipPath = function (value) {
      clipPath = 'url(' + value + ')';
      return line;
    };
    line.withMultipleLine = function (value) {
      withMultipleLine = value;
      return line;
    };
    return line;
  };
};
VerticalLine.$inject = ['d3Helper', 'ChartElementsConstants'];
module.exports = VerticalLine;